import React, { Component, useEffect, useState } from 'react';
import ServiceRequestsView from './ServiceRequestsView';
import crmservices from '../../wsclient/crmservices';
import { getCurrency } from '../../utils/common';
import NewServiceRequestView from './NewServiceRequestView';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';

function NewServiceRequestController(props) {
            const [showLoading, onShowLoading] = useState(false);
            const [request_info, setRequestInfo] = useState({});
            const [queues, setQueues] = useState([]);
            const [error, setError] = useState({})
    useEffect(()=>{
        getQueues();
    },[])
    const getQueues = async() =>{
        onShowLoading(true);
        let result = await crmservices.config.getQueues();
        if (result.code === 'OK' && result.data && result.data.content){
            let queues = [...result.data.content]
            queues.forEach(element => {
                element.label = element.name
                element.value = element.id
            });
            setQueues(queues);
        }
          
        onShowLoading(false);
     }

    const onCreate = async(values) =>{
        if(!request_info.queue_id){
            showAlert(true, t('please_chosse_classification'));
            return;
        }
        let new_request_info = {...request_info};
        new_request_info.description = values.description;

        setRequestInfo(prevState =>({
            ...prevState,
            description: values.description
        }))
        onShowLoading(true);
        try{
            let result = await crmservices.config.createServiceRequest(new_request_info);
            if (result.code==='OK'){
                showAlert(true, t('create_service_request_success'), props.onCloseAndRefresh);
            }
            else{
                showAlert(true, t('create_service_request_failed'));
            }
        }
        catch(e){
            showAlert(true, t('EXCEPTION_PROCESS'))
        }

        onShowLoading(false);      
    }
    const onSelectQueue = (value) =>{
        //console.log('onSelectQueue value===', value)
        setRequestInfo(prevState =>({
            ...prevState,
            queue_id: value.value
        }))
    }
    const showAlert = (status, message, callback) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            callback: callback
        })
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        if(error.callback){
            error.callback();
        }
        setError({
            showAlert: false,
            message: '',
            status: '',
            callback: null
        })
    }
    return (
        <div>
            <NewServiceRequestView 
                open={props.open} 
                onClose= {props.onClose}
                request_info = {request_info}
                showLoading = {showLoading}
                queues={queues}
                onCreate={onCreate}
                onSelectQueue={onSelectQueue}/>
            {error.showAlert &&<ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />}
        </div>
    );
}

export default NewServiceRequestController;